module.exports = __webpack_public_path__ + "b210f3be2cbaa8770383ca86542f29da.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MX.svg
// module id = 4323
// module chunks = 0